const API_BASE = process.env.REACT_APP_API;

if (!API_BASE && process.env.NODE_ENV !== "test") {
  console.error("REACT_APP_API is not set — API calls will fail.");
}

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

function authHeader() {
  const token = localStorage.getItem("authJWT");
  return token ? { Authorization: token } : {};
}

export async function apiFetch(path, options = {}) {
  const { skipAuth = false, headers = {}, ...rest } = options;

  const response = await fetch(`${API_BASE}${path}`, {
    ...rest,
    headers: {
      "Content-Type": "application/json",
      ...(skipAuth ? {} : authHeader()),
      ...headers,
    },
  });

  if (response.status === 401 && !skipAuth) {
    // Only treat 401 as a real session loss when we're confident we're online.
    // navigator.onLine === false means the browser knows we're offline; in that
    // case keep the cached UI and don't bounce the user to /login.
    if (navigator.onLine !== false) {
      localStorage.removeItem("authJWT");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    throw new ApiError("Unauthorized", 401);
  }

  return response;
}

export async function apiJson(path, options = {}) {
  const response = await apiFetch(path, options);
  if (!response.ok) {
    throw new ApiError(`Request failed: ${response.status}`, response.status);
  }
  return response.json();
}

export function isAuthTokenPresent() {
  return Boolean(localStorage.getItem("authJWT"));
}

export function clearAuth() {
  localStorage.removeItem("authJWT");
}

export function setAuthToken(token) {
  localStorage.setItem("authJWT", token);
}
